import * as Yup from "yup";
import { ErrorMessage, Field, Form, Formik, FormikHelpers } from "formik";
import type { DepartmentMutationData } from "../apis/interfaces/common";
import { Modal } from "react-bootstrap";

interface DepartmentFormProps {
  initialValues: DepartmentMutationData;
  onSubmit: any;
  onCancel: any;
}

const validationSchema = Yup.object({
  department: Yup.string().required("Department name is required"),
  department_number: Yup.string(),
});

const DepartmentForm = (props: DepartmentFormProps) => {
  const { initialValues, onSubmit, onCancel } = props;
  const handleSubmit = (
    values: DepartmentMutationData,
    { setStatus }: FormikHelpers<DepartmentMutationData>
  ) => {
    try {
      validationSchema.validateSync(values, { abortEarly: false });
      onSubmit(values);
    } catch (errors) {
      setStatus("An error occurred during form submission.");
    }
  };
  return (
    <Formik
      initialValues={initialValues}
      onSubmit={handleSubmit}
      validationSchema={validationSchema}
    >
      {({ handleChange, handleSubmit, isSubmitting, isValid }) => (
        <>
          <Form onSubmit={handleSubmit}>
            <Modal.Body>
              <div className="form-group mb-2">
                <label htmlFor="department">Department Name:</label>
                <Field
                  type="text"
                  id="department"
                  name="department"
                  className="form-control"
                  onChange={handleChange}
                />
                <ErrorMessage
                  name="department"
                  component="div"
                  className="error-message text-danger"
                />
              </div>

              <div className="form-group mb-2">
                <label htmlFor="department">Department Number:</label>
                <Field
                  type="text"
                  id="department_number"
                  name="department_number"
                  className="form-control"
                  onChange={handleChange}
                />
                <ErrorMessage
                  name="department_number"
                  component="div"
                  className="error-message text-danger"
                />
              </div>

              <div className="form-check mb-2">
                <Field
                  type="checkbox"
                  id="active"
                  name="active"
                  className="form-check-input"
                  onChange={handleChange}
                />
                <label className="form-check-label" htmlFor="active">
                  Active
                </label>
              </div>
            </Modal.Body>
            <Modal.Footer>
              <div className="text-right">
                <button
                  onClick={onCancel}
                  className="btn btn-sm btn-danger mx-3"
                  type="button"
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className="btn btn-sm btn-success"
                  disabled={!(!isSubmitting && isValid)}
                >
                  Save
                </button>
              </div>
            </Modal.Footer>
          </Form>
        </>
      )}
    </Formik>
  );
};

export default DepartmentForm;
